export default __webpack_public_path__ + "static/media/ic_location_black.cd7ce1ad.svg";